document.addEventListener("DOMContentLoaded", () => {
  const mobileMenu = document.getElementById("mobileMainMenu");

  function setMobileMenuState(isOpen) {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle("show", isOpen);
    document.body.classList.toggle("mobile-menu-open", isOpen);
    mobileMenu.setAttribute("aria-hidden", String(!isOpen));
    document.querySelectorAll(".navbar-toggler[data-target='#mobileMainMenu']").forEach((btn) => {
      btn.setAttribute("aria-expanded", String(isOpen));
    });
  }

  function closeMobileMenu() {
    setMobileMenuState(false);
  }

  document.querySelectorAll("[data-dismiss-site-alert]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const row = btn.closest("[data-site-alert]");
      if (row) {
        row.remove();
      }
      const stack = document.getElementById("site-alerts");
      if (stack && !stack.querySelector("[data-site-alert]")) {
        stack.remove();
      }
    });
  });

  document.querySelectorAll(".dropdown-menu").forEach((menu) => {
    menu.addEventListener("click", (event) => event.stopPropagation());
  });

  document.querySelectorAll(".navbar-toggler[data-target]").forEach((button) => {
    button.addEventListener("click", () => {
      const targetSelector = button.getAttribute("data-target");
      if (!targetSelector) return;
      const target = document.querySelector(targetSelector);
      if (!target) return;

      if (targetSelector === "#mobileMainMenu") {
        const isOpen = target.classList.contains("show");
        setMobileMenuState(!isOpen);
        return;
      }

      target.classList.toggle("show");
      const expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
    });
  });

  if (mobileMenu) {
    mobileMenu.setAttribute("aria-hidden", "true");

    mobileMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", closeMobileMenu);
    });

    document.addEventListener("click", (event) => {
      if (!mobileMenu.classList.contains("show")) return;
      const target = event.target;
      if (!(target instanceof Element)) return;

      const clickedToggle = target.closest(".navbar-toggler[data-target='#mobileMainMenu']");
      if (clickedToggle) return;

      const insideMenu = target.closest("#mobileMainMenu");
      if (!insideMenu) {
        closeMobileMenu();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && mobileMenu.classList.contains("show")) {
        closeMobileMenu();
      }
    });
  }
});

window.copyText = function copyText(button, value) {
  if (!value) return;
  navigator.clipboard
    .writeText(value)
    .then(() => {
      if (!button) return;
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.trim();
      }
      button.textContent = "Скопійовано";
      button.classList.add("is-copied");

      window.setTimeout(() => {
        button.textContent = button.dataset.originalText || "Копіювати";
        button.classList.remove("is-copied");
      }, 1800);
    })
    .catch(() => {
      if (!button) return;
      button.textContent = "Помилка";
      window.setTimeout(() => {
        button.textContent = button.dataset.originalText || "Копіювати";
      }, 1200);
    });
};

window.updateCartItem = function updateCartItem(selectElement, cartItemId) {
  if (!window.cartConfig) return;
  const quantity = selectElement.value;
  fetch(window.cartConfig.updateUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": window.cartConfig.csrfToken,
    },
    body: JSON.stringify({
      cart_item_id: cartItemId,
      quantity: quantity,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        window.location.reload();
      } else {
        alert("Помилка оновлення кошика");
      }
    });
};
